import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { trackPageView } from "@/lib/ga4";

/**
 * Headless component that wires React Router to GA4. Mounts inside the
 * BrowserRouter (so ``useLocation`` works) and fires a ``page_view`` event
 * every time the SPA navigates — including the initial landing.
 *
 * Document title can change ASYNCHRONOUSLY (SEO component sets it via
 * react-helmet-async after the route mounts), so we wait one
 * ``requestAnimationFrame`` before reading it. Without that delay the
 * first event reports the previous page's title.
 */
export default function GA4Tracker() {
  const { pathname, search } = useLocation();

  useEffect(() => {
    // Defer so react-helmet has time to update <title> with the route's
    // SEO component before we sample document.title for the event.
    const raf = window.requestAnimationFrame(() => {
      trackPageView(pathname, search);
    });
    return () => window.cancelAnimationFrame(raf);
  }, [pathname, search]);

  return null;
}
